// extracted by mini-css-extract-plugin
module.exports = {"childrenWrapper":"style_childrenWrapper__NpebU"};